import React from 'react';
import { Box, Typography, Paper, useTheme } from '@mui/material';

type TypographyVariant =
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'h5'
  | 'h6'
  | 'subtitle1'
  | 'subtitle2'
  | 'body1'
  | 'body2'
  | 'button'
  | 'caption'
  | 'overline';

const TypographyShowcase = () => {
  const theme = useTheme();

  const typographyVariants: { name: TypographyVariant; text: string }[] = [
    { name: 'h1', text: 'Heading 1' },
    { name: 'h2', text: 'Heading 2' },
    { name: 'h3', text: 'Heading 3' },
    { name: 'h4', text: 'Heading 4' },
    { name: 'h5', text: 'Heading 5' },
    { name: 'h6', text: 'Heading 6' },
    { name: 'subtitle1', text: 'Subtitle 1' },
    { name: 'subtitle2', text: 'Subtitle 2' },
    { name: 'body1', text: 'Body 1 - The quick brown fox jumps over the lazy dog.' },
    { name: 'body2', text: 'Body 2 - The quick brown fox jumps over the lazy dog.' },
    { name: 'button', text: 'Button Text' },
    { name: 'caption', text: 'Caption Text' },
    { name: 'overline', text: 'Overline Text' },
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Typography
      </Typography>
      <Typography variant="body1" paragraph>
        These are the typography styles used throughout the application. They are defined in the theme and can be
        accessed using the theme.typography object.
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {typographyVariants.map((variant) => (
          <Paper
            key={variant.name}
            elevation={1}
            sx={{
              p: 2,
              display: 'flex',
              flexDirection: 'column',
            }}>
            <Typography variant="subtitle2" color="text.secondary">
              {variant.name}
            </Typography>
            <Typography
              variant={variant.name}
              sx={{
                mt: 1,
                fontFamily: theme.typography[variant.name].fontFamily,
                fontSize: theme.typography[variant.name].fontSize,
                fontWeight: theme.typography[variant.name].fontWeight,
                lineHeight: theme.typography[variant.name].lineHeight,
                letterSpacing: theme.typography[variant.name].letterSpacing,
              }}>
              {variant.text}
            </Typography>
          </Paper>
        ))}
      </Box>
    </Box>
  );
};

export default TypographyShowcase;
